import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Nav from "../components/layout/Nav";
import Footer from "../components/layout/Footer";

export default function NotFound() {
  return (
    <>
      <Nav />
      <main
        className="relative bg-brand-primary text-white min-h-screen flex items-center overflow-hidden"
        data-testid="notfound-page"
      >
        <div
          aria-hidden
          className="absolute inset-0 bg-grid opacity-40 pointer-events-none"
        />
        <div
          aria-hidden
          className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full glow-radial"
        />

        <div className="relative max-w-[90rem] mx-auto px-6 sm:px-8 lg:px-12 py-32 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <p className="eyebrow text-brand-accent">Fehler 404</p>
            <h1 className="mt-6 font-display font-medium text-6xl sm:text-8xl lg:text-[10rem] leading-[0.9] tracking-tighter">
              Verlaufen.
            </h1>
            <p className="mt-8 text-white/70 text-lg max-w-lg">
              Diese Seite existiert nicht — oder nicht mehr. Zurück zum Start
              führt der schnellste Weg.
            </p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Link to="/" className="btn-primary" data-testid="notfound-home">
                Zur Startseite <ArrowUpRight className="h-4 w-4" />
              </Link>
              <Link
                to="/#kontakt"
                className="btn-secondary btn-secondary--dark"
                data-testid="notfound-contact"
              >
                Kontakt aufnehmen
              </Link>
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div
              aria-hidden
              className="text-[16rem] lg:text-[22rem] font-bold leading-none tracking-tighter text-white/5 select-none"
            >
              404
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
